
import React from 'react'
import "./styles.scss"

import assets, { plans } from '../../utils/assets'

const PricingCards = () => {

    return (
        <div className="container">
            <div className="row d-flex gap-4 justify-content-center">
                {plans.map((plan, index) => (
                    <div key={index} className="col-xl col-md-5 col-sm-12">
                        <div className={`planCard ${plan.isFeatured === true ? "cardFocus" : ""}`}>
                            <div className="planCardWrap">
                                <div className="planCardContent text-center">
                                    <h2>{plan.title}</h2>
                                    <p>{plan.description}</p>
                                    <div className="price">{plan.price}<label>per month</label></div>
                                    <label>{plan.billing}</label>
                                </div>
                                <div className="lineBreak my-4"></div>
                                <div className="keyPoints">
                                    <ul >
                                        {plan.features.map((feature, idx) => (
                                            <li className={`${feature.subpoints?.length > 0 ? "hasSubpoints" : ""}`} key={idx}>
                                                <div className={`${feature.subpoints?.length > 0 ? "mainPoint" : "d-flex gap-3"}`}>
                                                    <img src={assets.CheckMark} alt="" />
                                                    <h6>{feature.text}</h6>
                                                </div>
                                                {feature.subpoints && (
                                                    <ul className="subpoints">
                                                        {feature.subpoints.map((sub, i) => (
                                                            <li key={i}>{sub}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="row row-gap-2">
                                <div className={`${plan.secondarybtn.length > 2 ? "col-12 col-sm-6" : "col-12"}`}>
                                    <div className="getbtn">
                                        {plan.primarybtn}
                                    </div>
                                </div>
                                <div className={`${plan.secondarybtn.length > 2 ? "col" : "d-none"}`}>
                                    <div className="demobtn">
                                        {plan.secondarybtn}
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

}

export default PricingCards